/* FULLHED shade quiz v2 controller.
   4 questions with real logic across all 7 shades (black to white) and a 2-tier
   result: a clear match, or between-two-shades (adds a 2-pack of both shades).
   Works on any page that renders the fh-quiz snippet. Emits fhTrack events per step. */
(function () {
  if (window.__fhQuizInit) return;
  window.__fhQuizInit = true;

  function track() { return (window.fhTrack || function () {}).apply(null, arguments); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  var TIPS = {
    crown: 'Hold the bottle above your crown and shake in small circles, then pat to settle.',
    hairline: 'Use less along the hairline and build slowly. The precision applicator in the Starter Kit keeps the front line clean and natural.',
    overall: 'Work section by section, patting as you go, and check the result in natural light.'
  };
  var BASE = { black: 'Black', darkbrown: 'Dark Brown', mediumbrown: 'Medium Brown', lightbrown: 'Medium Brown', greywhite: 'Grey Blend' };
  var BROWN = ['darkbrown', 'mediumbrown', 'lightbrown'];

  function init() {
    var overlay = document.querySelector('[data-fh-quiz]');
    if (!overlay) return;

    var cfg = {};
    try { cfg = JSON.parse(overlay.querySelector('[data-fh-quiz-config]').textContent); } catch (e) {}
    var colors = cfg.colors || {};
    var variants = cfg.variants || {};

    var progress = overlay.querySelectorAll('.fh-quiz__progress span');
    var resultBox = overlay.querySelector('[data-fh-quiz-result]');
    var state = {};
    var current = 'root';

    function stepEl(id) { return overlay.querySelector('[data-step="' + id + '"]'); }
    function isBrown() { return BROWN.indexOf(state.root) !== -1; }
    // Warmth splits brown blends AND blonde vs light blonde, so ask it for both.
    function needsWarmth() { return isBrown() || state.root === 'blonde'; }
    function qseq() { return needsWarmth() ? ['root', 'warm', 'grey', 'area'] : ['root', 'grey', 'area']; }

    function updateProgress(id) {
      var seq = qseq();
      var n = seq.indexOf(id);
      var filled = n >= 0 ? n + 1 : seq.length;
      progress.forEach(function (p, i) {
        p.style.display = i < seq.length ? '' : 'none';
        p.classList.toggle('is-active', i < filled);
      });
    }
    function show(id) {
      current = id;
      overlay.querySelectorAll('.fh-quiz__step').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') === id); });
      updateProgress(id);
    }
    function nextOf(id) {
      switch (id) {
        case 'root': return needsWarmth() ? 'warm' : 'grey';
        case 'warm': return 'grey';
        case 'grey': return 'area';
        case 'area': return 'email';
        case 'email': return 'result';
      }
      return 'result';
    }

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      state = {}; show('root');
      track('fh_quiz_start', { source: overlay.getAttribute('data-fh-quiz-source') || 'page' });
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-fh-quiz-open]');
      if (opener) { e.preventDefault(); open(); }
    });
    overlay.querySelector('.fh-quiz__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });

    // Question option / tile clicks
    overlay.querySelectorAll('.fh-quiz__opt, .fh-quiz__tile').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var q = opt.dataset.q, v = opt.dataset.value;
        state[q] = v;
        track('fh_quiz_answer', { question: q, answer: v, step: qseq().indexOf(current) + 1 });
        show(nextOf(current));
      });
    });

    // Email step
    var emailInput = overlay.querySelector('[data-fh-quiz-email]');
    var emailContinue = overlay.querySelector('[data-fh-quiz-email-continue]');
    var emailSkip = overlay.querySelector('[data-fh-quiz-email-skip]');
    if (emailContinue) emailContinue.addEventListener('click', function () {
      var v = (emailInput && emailInput.value || '').trim();
      if (!validEmail(v)) { if (emailInput) { emailInput.focus(); emailInput.classList.add('is-error'); } return; }
      try { localStorage.setItem('fh_email', v); } catch (e) {}
      track('fh_quiz_email', { captured: true });
      finish();
    });
    if (emailSkip) emailSkip.addEventListener('click', function () {
      track('fh_quiz_email', { captured: false });
      finish();
    });

    function computeOutcome() {
      // Fully white / silver hair reads as the White shade; heavy grey as Grey Blend.
      if (state.grey === 'allwhite') return { tier: 'match', shade: 'White' };
      if (state.grey === 'mostly') return { tier: 'match', shade: 'Grey Blend' };

      // Blonde roots now get a real match: warm gold -> Blonde, cool/light -> Light Blonde,
      // salt & pepper blonde -> blend with Grey Blend, and darker/uncertain blonde -> blend
      // toward Medium Brown (e.g. dark blonde = Blonde + Medium Brown 70/30).
      if (state.root === 'blonde') {
        if (state.grey === 'saltpepper') return { tier: 'mix', primary: 'Blonde', secondary: 'Grey Blend' };
        if (state.warm === 'warm') return { tier: 'match', shade: 'Blonde' };
        if (state.warm === 'cool') return { tier: 'match', shade: 'Light Blonde' };
        return { tier: 'mix', primary: 'Blonde', secondary: 'Medium Brown' };
      }

      var base = BASE[state.root] || 'Medium Brown';
      if (state.grey === 'saltpepper') {
        if (base === 'Grey Blend') return { tier: 'match', shade: 'Grey Blend' };
        return { tier: 'mix', primary: base, secondary: 'Grey Blend' };
      }
      if (isBrown() && state.warm === 'notsure') {
        if (base === 'Dark Brown') return { tier: 'mix', primary: 'Dark Brown', secondary: 'Medium Brown' };
        return { tier: 'mix', primary: 'Medium Brown', secondary: 'Dark Brown' };
      }
      return { tier: 'match', shade: base };
    }

    function persist(o) {
      // Cart attributes + localStorage for downstream (PDP selector, checkout)
      var attrs = { 'Quiz root': state.root || '', 'Quiz grey': state.grey || '', 'Quiz area': state.area || '' };
      if (state.warm) attrs['Quiz warmth'] = state.warm;
      if (o.tier === 'match') attrs['Quiz shade'] = o.shade;
      if (o.tier === 'mix') attrs['Quiz shade'] = o.primary + ' + ' + o.secondary;
      try {
        localStorage.setItem('fh_quiz', JSON.stringify(state));
        if (o.shade) localStorage.setItem('fh_shade', o.shade);
        else if (o.primary) localStorage.setItem('fh_shade', o.primary);
      } catch (e) {}
      try {
        fetch((window.Shopify ? window.Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs })
        });
      } catch (e) {}
    }

    function dot(shade) { return '<span class="fh-quiz__result-dot" style="background:' + (colors[shade] || '#333') + '"></span>'; }

    function finish() {
      var o = computeOutcome();
      persist(o);
      track('fh_quiz_complete', { tier: o.tier, shade: o.shade || null, primary: o.primary || null, secondary: o.secondary || null });
      show('result');
      var tip = TIPS[state.area] || TIPS.overall;
      var html = '';

      if (o.tier === 'match') {
        html =
          '<div class="fh-quiz__res">' + dot(o.shade) +
          '<p class="fh-eyebrow">Your match</p>' +
          '<h3 class="fh-quiz__q">' + esc(o.shade) + '</h3>' +
          '<p class="fh-quiz__hint">' + esc(tip) + '</p>' +
          '<button type="button" class="fh-btn fh-btn--primary fh-btn--block" data-use="' + esc(o.shade) + '">Use this shade</button>' +
          '<p class="fh-quiz__mixnote">Between two shades? Mixing is normal, order both and blend.</p>' +
          '</div>';
      } else if (o.tier === 'mix') {
        html =
          '<div class="fh-quiz__res">' +
          '<div class="fh-quiz__dots2">' + dot(o.primary) + dot(o.secondary) + '</div>' +
          '<p class="fh-eyebrow">Between two shades</p>' +
          '<h3 class="fh-quiz__q">You\'re between two shades, and that\'s normal.</h3>' +
          '<p class="fh-quiz__hint">Pro move: mix them. Most barbers do exactly this.</p>' +
          '<div class="fh-quiz__mix">' +
            '<div class="fh-quiz__mix-row">' + dot(o.primary) + '<span>' + esc(o.primary) + '</span><b>70%</b></div>' +
            '<div class="fh-quiz__mix-row">' + dot(o.secondary) + '<span>' + esc(o.secondary) + '</span><b>30%</b></div>' +
            '<p class="fh-quiz__mix-note">Start 70/30 and adjust in the mirror. ' + esc(tip) + '</p>' +
          '</div>' +
          '<button type="button" class="fh-btn fh-btn--primary fh-btn--block" data-mix="' + esc(o.primary) + '|' + esc(o.secondary) + '">Add both shades (2-pack)</button>' +
          '<button type="button" class="fh-quiz__skip" data-use="' + esc(o.primary) + '">Just use ' + esc(o.primary) + '</button>' +
          '</div>';
      }
      resultBox.innerHTML = html;
    }

    function useShade(shade) {
      if (window.fhSelectShade) { window.fhSelectShade(shade); close(); }
      else { window.location.href = (cfg.productUrl || '/') + (cfg.productUrl && cfg.productUrl.indexOf('?') > -1 ? '&' : '?') + 'shade=' + encodeURIComponent(shade); }
    }

    function addMix(primary, secondary) {
      var v1 = variants[primary], v2 = variants[secondary];
      if (!v1 || !v2) { window.location.href = cfg.productUrl || '/'; return; }
      track('fh_quiz_addmix', { primary: primary, secondary: secondary });
      fetch((window.Shopify ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v1, quantity: 1 }, { id: v2, quantity: 1 }] })
      }).then(function () {
        if (window.fhCart) { close(); window.fhCart.open(); }
        else { window.location.href = cfg.cartUrl || '/cart'; }
      }).catch(function () { window.location.href = cfg.cartUrl || '/cart'; });
    }

    // Delegated actions inside the result
    resultBox.addEventListener('click', function (e) {
      var use = e.target.closest('[data-use]');
      if (use) { useShade(use.getAttribute('data-use')); return; }
      var mix = e.target.closest('[data-mix]');
      if (mix) { var parts = mix.getAttribute('data-mix').split('|'); addMix(parts[0], parts[1]); return; }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
